<!--  -->
<template>
  <div class="claims">
    <h4 class="centerh4">认领学者</h4>
    <div class="center-con">
      <div>
        <h2>您需要满足以下条件方可开启学者认领</h2>
        <div class="real">
          <div class="real-info">
            <img src="../../assets/img/overinfo.svg" alt>
            <p>您还未完善学者信息</p>
            <el-button class="real-btn" type="primary">去完善</el-button>
          </div>
          <div class="real-info">
            <img src="../../assets/img/realname.svg" alt>
            <p>您还未完善实名认证</p>
            <el-button class="real-btn" type="primary">去完善</el-button>
          </div>
        </div>
      </div>
      <div>
        <h2>已认领学者</h2>
        <p class="way">管理学 > 图书档案管理 > 图书馆学</p>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="180"></el-table-column>
            <el-table-column prop="name" align="center" label="姓名" width="180"></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
          </el-table>
        </div>
        <h2>待认领学者</h2>
        <div class="pl15">
          <p class="title">以下为与您姓名和单位一致的上榜学者</p>
          <p class="claimstips">* 提示：当确定某位学者是您本人时，您可认领该学者并获得其编辑权。</p>
          <p class="way mt10">管理学 > 图书档案管理 > 图书馆学</p>
        </div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="180"></el-table-column>
            <el-table-column prop="name" align="center" label="姓名" width="180"></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
          </el-table>
        </div>
        <div class="pl15">
          <p class="title">以下为与您姓名相同但单位不同的上榜学者</p>
          <p class="claimstips">* 提示：系统有时无法确定同名不同单位的学者是否为同一人，此时会生成多条记录，认领后数据将会和同学科的数据合并</p>
          <p class="way mt10">管理学 > 图书档案管理 > 图书馆学</p>
        </div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="180"></el-table-column>
            <el-table-column prop="name" align="center" label="姓名" width="180"></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.pl15 {
  padding-left: 15px;
}
.mt10 {
  margin-top: 10px !important;
}
.real {
  text-align: center;
  padding-top: 100px;
}
.real-info {
  display: inline-block;
  width: 200px;
  text-align: center;
  font-size: 14px;
}
.real-info p {
  margin-top: 20px;
  margin-bottom: 25px;
  color: #999999;
}
.real-btn {
  background: rgba(66, 103, 178, 1) !important;
  border-color: rgba(66, 103, 178, 1) !important;
  width: 74px;
  height: 32px;
  border-radius: 2px;
  text-align: center;
  padding: 0 !important;
}
.claims .claimstips {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.claims .title {
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  color: rgba(68, 68, 68, 1);
  line-height: 20px;
}
.claims .way {
  margin-top: 15px;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.centerh4 {
  font-size: 16px;
  font-weight: 700;
  color: rgba(68, 68, 68, 1);
  line-height: 22px;
}
.center-con h2 {
  height: 20px;
  line-height: 20px;
  padding-left: 10px;
  font-size: 14px;
  color: #444;
  position: relative;
  margin-top: 20px;
  /* margin-bottom: 15px; */
  font-weight: normal;
}
.center-con h2:before {
  content: "";
  width: 2px;
  height: 15px;
  position: absolute;
  left: 0px;
  top: 2px;
  background-color: #4267b2;
}
.claims .table {
  margin-top: 15px;
}

.table .el-table th {
  background: rgba(66, 103, 178, 0.06);
  color: #999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/personalCenter/claimscholar.vue